<template>
  <div class="relative budget-item"
       @click.prevent="$emit('select')">
    <div class="budget-item-grid group"
         :class="{'selected': !!budgetSelected ? id === budgetSelected.id : false}">
      <div class="col-span-5 flex items-center">
        <MKIcons :icon="icon || ''"
                 class="rounded-full flex flex-none items-center justify-center text-white mr-4"
                 style="width: 2.4rem;height: 2.4rem;"
                 :class="type === 2 ? 'bg-red' : 'bg-green' "/>
        <div class="text-text-secondary font-medium text-sm truncate">{{ title }}</div>
        <BudgetItemCommentEdit :id="id"
                               :type="type"
                               :comment="comment"/>
      </div>
      <div class="col-span-2 whitespace-no-wrap text-right text-sm">
        <BudgetItemValueEdit :id="id"
                             :type="type"
                             :plan_sum="displayCurrencyValue(+sum_plan, currency, false)"/>
      </div>
      <div class="col-span-2 whitespace-no-wrap text-right text-sm text-text-secondary relative">
        {{ displayCurrencyValue(+sum_fact, currency, false) }}
        <font-awesome-icon v-if="excluded_transactions >=1"
                           icon="exclamation-triangle"
                           class="text-yellow text-xs -mr-7 mt-0-5 absolute right-0 top-1"
                           v-tooltip="$t('warningTooltip')"/>
      </div>
      <div class="col-span-2 whitespace-no-wrap text-right text-sm font-medium"
           v-html="getDifference(sum_plan,sum_fact)"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import BudgetItemCommentEdit from "@/components/cabinet/Money/Budgets/BugetItem/BudgetItemCommentEdit";
import BudgetItemValueEdit from "@/components/cabinet/Money/Budgets/BugetItem/BudgetItemValueEdit";
import MKIcons from "@/components/icons/MKIcons/MKIcons";

export default {
  name: "BudgetItem",
  components: {
    MKIcons,
    BudgetItemValueEdit,
    BudgetItemCommentEdit
  },
  props: {
    id: {
      type: Number
    },
    type: {
      type: Number
    },
    icon: {
      type: String
    },
    title: {
      type: String
    },
    comment: {
      type: String
    },
    sum_plan: {
      type: Number
    },
    sum_fact: {
      type: Number
    },
    excluded_transactions: {
      type: Number
    },
    currency: {
      type: Object
    }
  },
  computed: {
    ...mapState('space/budgets', ['budgetSelected']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  methods: {
    getDifference(plan, fact) {
      if ([1, 3, 4].includes(this.type)) {
        const diff = fact - plan;
        return this.valueColored(diff);
      } else {
        const diff = plan - fact;
        return this.valueColored(diff);
      }
    },
    valueColored(val) {
      let colorClass = val > 0 ? 'text-green' : 'text-red';
      return !!val
          ? `<span class="${colorClass}">${this.displayCurrencyValue(val, this.currency, false)}</span>`
          : ''
    }
  },
  i18n: {
    messages: {
      en: {
        warningTooltip: 'There are unaccounted transactions in the budget'
      },
      ru: {
        warningTooltip: 'В бюджете есть неучтенные транзакции'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.budget-item-grid {
  @apply grid grid-cols-11 col-gap-3 py-4 items-center relative z-10 -mx-6 px-6
  rounded border border-transparent cursor-pointer;
  transition: all .2s;

  &:hover {
    @apply bg-line border-line;
  }

  &.selected {
    @apply bg-line border-border-hover z-60;
  }
}

.budget-item {
  @apply relative -mb-px;

  &:not(:last-of-type):after {
    @apply bg-line;
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 1px;
    z-index: 1;
  }
}
</style>